import VueRouter, { RouteConfig } from 'vue-router'

const List = () => import('../views/homework-check-ai/Index.vue')
const Redo = () => import('../views/homework-check-ai/Redo.vue')
const Urge = () => import('../views/homework-check-ai/Urge.vue')
const Clazz = () => import('../views/homework-check-ai/Clazz.vue')
const Pending = () => import('../views/homework-check-ai/Pending.vue')
const Student = () => import('../views/homework-check-ai/Student.vue')
const Drill = () => import('../views/homework-check-ai/drill/Index.vue')

export const homeworkCheckAiListRoute: RouteConfig = {
  path: '/homework-check-ai',
  name: 'homework_check_ai',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '检查作业',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiClazzRoute: RouteConfig = {
  path: '/homework-check-ai-clazz',
  name: 'homework_check_ai_clazz',
  component: Clazz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '班级详情',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiStudentRoute: RouteConfig = {
  path: '/homework-check-ai-student',
  name: 'homework_check_ai_student',
  component: Student,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生档案',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiDrillRoute: RouteConfig = {
  path: '/homework-check-ai-drill',
  name: 'homework_check_ai_drill',
  component: Drill,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '批改作业',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiRedoRoute: RouteConfig = {
  path: '/homework-check-ai-redo',
  name: 'homework_check_ai_redo',
  component: Redo,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '重做',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiPendingRoute: RouteConfig = {
  path: '/homework-check-ai-pending',
  name: 'homework_check_ai_pending',
  component: Pending,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '待确认',
    hideTitleBar: true,
  },
}

export const homeworkCheckAiUrgeRoute: RouteConfig = {
  path: '/homework-check-ai-urge',
  name: 'homework_check_ai_urge',
  component: Urge,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '催交作业',
    hideTitleBar: true,
  },
}

export default [
  homeworkCheckAiListRoute,
  homeworkCheckAiClazzRoute,
  homeworkCheckAiStudentRoute,
  homeworkCheckAiDrillRoute,
  homeworkCheckAiRedoRoute,
  homeworkCheckAiPendingRoute,
  homeworkCheckAiUrgeRoute,
]

export function navigateToHomeworkCheckAiList(router: VueRouter) {
  router.push({ name: homeworkCheckAiListRoute.name })
}

export function navigateToHomeworkCheckAiClazz(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiClazzRoute.name, query })
}

export function navigateToHomeworkCheckAiStudent(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiStudentRoute.name, query })
}

export function navigateToHomeworkCheckAiDrill(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiDrillRoute.name, query })
}

export function navigateToHomeworkCheckAiRedo(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiRedoRoute.name, query })
}

export function navigateToHomeworkCheckAiPending(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiPendingRoute.name, query })
}

export function navigateToHomeworkCheckAiUrge(router: VueRouter, query: Record<string, string> = {}) {
  router.push({ name: homeworkCheckAiUrgeRoute.name, query })
}
